import McpAdminPage from './McpAdminPage';

export default McpAdminPage;
